import _defineProperty from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["listing", "onOk"];
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { AppContext } from "../DixuApp/DixuApp";
import DixuCheckbox from "../DixuCheckbox/DixuCheckbox";
import DixuForm from "../DixuForm/DixuForm";
import { DixuCol, DixuRow } from "../DixuGrid/DixuGrid";
import DixuInput from "../DixuInput/DixuInput";
import DixuLink from "../DixuLink/DixuLink";
import DixuModal from "../DixuModal/DixuModal";
import DixuNotification from "../DixuNotification/DixuNotification";
import DixuRadio from "../DixuRadio/DixuRadio";
import DixuText from "../DixuText/DixuText";
import DixuTooltip from "../DixuTooltip/DixuTooltip";
import useIsLoading from "../../hooks/useIsLoading";
import { useTranslation } from "../../i18n";
import React, { useContext } from 'react';
import { getErrorDescription, sendLoanApplication } from "../../services/ApiService";
import NordeaIcon from "../../public/images/nordea.svg";
import { toRem } from "../../utils/Utils";
const DixuMortgageFormModal = _ref => {
  let {
      listing,
      onOk
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const {
    t
  } = useTranslation(['common']);
  const [form] = DixuForm.useForm();
  const {
    user
  } = useContext(AppContext);
  const {
    id: listingID
  } = listing || {};
  const [submit, isSubmitting] = useIsLoading(async values => {
    try {
      await sendLoanApplication({
        listingID,
        data: _objectSpread(_objectSpread({}, values), {}, {
          banks: ['Nordea']
        })
      });
      DixuNotification.success({
        message: 'Laina-yhteydenottopyyntö on lähetetty!'
      });
      form.resetFields();
      onOk?.();
    } catch (error) {
      DixuNotification.error({
        message: 'Lähettäminen epäonnistui',
        description: getErrorDescription(error)
      });
    }
  });
  return /*#__PURE__*/React.createElement(DixuModal, _objectSpread(_objectSpread({}, rest), {}, {
    title: 'Lähetä yhteydenottopyyntö asuntolainasta',
    width: 582,
    loading: isSubmitting,
    okText: 'Lähetä yhteydenottopyyntö',
    onOk: null,
    okButtonProps: {
      htmlType: 'submit',
      form: 'mortgage'
    }
  }), /*#__PURE__*/React.createElement(DixuForm, {
    form: form,
    name: "mortgage",
    initialValues: {
      name: user?.displayName,
      email: user?.emails?.[0]?.value,
      tel: user?.tel
    },
    onFinish: submit
  }, /*#__PURE__*/React.createElement("div", {
    className: "m-b-16"
  }, /*#__PURE__*/React.createElement(DixuRow, {
    align: "bottom",
    gutter: [32, 16]
  }, /*#__PURE__*/React.createElement(DixuCol, null, /*#__PURE__*/React.createElement(NordeaIcon, {
    style: {
      height: toRem(24)
    }
  })))), /*#__PURE__*/React.createElement(DixuText, {
    font: "3",
    color: "2-8",
    block: true,
    className: "m-b-16"
  }, "Teemme yhteisty\xF6t\xE4 Nordean kanssa. V\xE4lit\xE4mme alla n\xE4kyv\xE4n yhteydenottopyynn\xF6n tiedot valitsemillesi pankeille, joista ollaan sinuun yhteydess\xE4."), /*#__PURE__*/React.createElement(DixuForm.Section, {
    wrapperCol: {
      span: 24
    }
  }, /*#__PURE__*/React.createElement(DixuRow, null, /*#__PURE__*/React.createElement(DixuCol, {
    xs: 24,
    md: 12
  }, /*#__PURE__*/React.createElement(DixuForm.Item, {
    name: "name",
    label: t('common:Name'),
    rules: [{
      required: true
    }]
  }, /*#__PURE__*/React.createElement(DixuInput, null)))), /*#__PURE__*/React.createElement(DixuRow, null, /*#__PURE__*/React.createElement(DixuCol, {
    xs: 24,
    md: 12
  }, /*#__PURE__*/React.createElement(DixuForm.Item, {
    name: "email",
    label: t('common:Email'),
    rules: [{
      required: true,
      type: 'email'
    }]
  }, /*#__PURE__*/React.createElement(DixuInput, {
    type: "email"
  })))), /*#__PURE__*/React.createElement(DixuRow, null, /*#__PURE__*/React.createElement(DixuCol, {
    xs: 24,
    md: 12
  }, /*#__PURE__*/React.createElement(DixuForm.Item, {
    name: "tel",
    label: t('common:Phone'),
    rules: [{
      required: true
    }]
  }, /*#__PURE__*/React.createElement(DixuInput, {
    type: "tel"
  })))), /*#__PURE__*/React.createElement(DixuForm.Item, {
    name: "primaryContactMethod",
    label: "Haluan yhteydenoton ensisijaisesti",
    rules: [{
      required: true
    }]
  }, /*#__PURE__*/React.createElement(DixuRadio.Group, {
    optionType: "button",
    buttonStyle: "solid",
    options: [{
      value: 'PHONE',
      label: t('common:Phone')
    }, {
      value: 'EMAIL',
      label: t('common:Email')
    }],
    separated: true
  })), /*#__PURE__*/React.createElement(DixuForm.Item, {
    noStyle: true,
    shouldUpdate: "primaryContactMethod"
  }, () => {
    const {
      primaryContactMethod
    } = form.getFieldsValue();
    return /*#__PURE__*/React.createElement(DixuForm.Item, {
      name: "bestReachedAt",
      label: "Minut tavoittaa parhaiten",
      rules: [{
        required: primaryContactMethod === 'PHONE'
      }]
    }, /*#__PURE__*/React.createElement(DixuRadio.Group, {
      optionType: "button",
      buttonStyle: "solid",
      options: ['9-12', '12-15', '15-18', '18-21'].map(value => {
        return {
          value,
          label: `klo ${value}`
        };
      }),
      separated: true
    }));
  }), /*#__PURE__*/React.createElement("div", {
    className: "m-t-16"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(DixuText, {
    font: "3",
    color: "2-6",
    weight: "bold"
  }, /*#__PURE__*/React.createElement(DixuTooltip.Info, {
    overlayWidth: "474",
    placement: "rightBottom",
    title: /*#__PURE__*/React.createElement(React.Fragment, null, "Nordea Bank Oyj k\xE4sittelee luoton my\xF6nt\xE4mist\xE4, k\xE4sittely\xE4 ja valvontaa varten tarvittavia henkil\xF6tietoja. N\xE4it\xE4 henkil\xF6tietoja hankitaan hakijalta, viranomaisten pit\xE4mist\xE4 rekistereist\xE4, Nordea Bank Oyj ja sen kanssa samaan konserniin kuuluvien yhti\xF6iden rekistereist\xE4, luottotietotoimintaa harjoittavilta yhteis\xF6ilt\xE4, kuten Suomen Asiakastieto Oy:n luottotietorekisterist\xE4 ja/tai muista luotettavista l\xE4hteist\xE4. Lis\xE4ksi Nordea Bank Oyj ker\xE4\xE4 tietoja my\xF6s vakuuksiin liittyvist\xE4 tietokannoista esimerkiksi kiinteist\xF6tietoj\xE4rjestelm\xE4st\xE4 tai is\xE4nn\xF6itsij\xE4ntodistuksesta. Asiakkaan tuntemiseen liittyvi\xE4 tietoja voidaan k\xE4ytt\xE4\xE4 luottop\xE4\xE4t\xF6ksen tekemiseen. Lis\xE4tietoja henkil\xF6tietojen k\xE4sittelyst\xE4 Nordea Bank Oyj:ssa annetaan Nordean tietosuojaselosteessa, joka saatavilla Nordean verkkosivuilla. Tietosuojaselosteen voi saada my\xF6s ottamalla yhteytt\xE4 Nordeaan.")
  }, "Henkil\xF6tietojen k\xE4ytt\xE4misest\xE4 Nordeassa")))))));
};
DixuMortgageFormModal.defaultProps = {};
export default DixuMortgageFormModal;